import React from 'react';
import {Provider} from 'react-redux';
import ReactDOM from 'react-dom';
import Store from './_redux/store';
import App from './containers/App/App';
import './bootstrap';
import './sentry';
import '../assets/styles.scss';

if (module && module.hot) {
    module.hot.accept();
}

ReactDOM.render(
        <React.StrictMode>
            <Provider store={Store}>
                <App/>
            </Provider>
        </React.StrictMode>,
        document.getElementById('app')
);
